import { QueryDatasourceMetadata } from '@root/Services/Query/QueryDatasource';
import { Coin, Icon, Packages, QuestionMark, SunHigh } from 'tabler-icons-react';

const descriptors: Record<string, { name: string; icon: Icon }> = {
    cur: { name: 'Costs', icon: Coin },
    resources: { name: 'Resources', icon: Packages },
    costforecast: { name: 'Cost Forecast', icon: SunHigh },
};
export function getDatasourceDescriptors() {
    return Object.keys(descriptors).map((key) => ({ dsName: key, ...descriptors[key] }));
}
export function describeDatasource(datasourceMeta: QueryDatasourceMetadata) {
    const descriptor = descriptors[datasourceMeta.name];
    return {
        name: datasourceMeta?.title ?? descriptor?.name ?? 'Unknown',
        icon: descriptor?.icon ?? QuestionMark,
    };
}
